import React, { type PropsWithChildren, useMemo } from 'react'
import { useThemeContext, Vertical } from '@gravitate-js/excalibrr'

type CellContainerProps = PropsWithChildren<{
  status?: 'default' | 'error' | 'success'
}>
export const CellContainer = ({ status = 'default', children }: CellContainerProps) => {
  const { isDarkTheme } = useThemeContext()
  const backgroundColor = useMemo(() => {
    //for now, no-op the "success" status due to feedback.
    //const base = status === 'success' ? 'var(--theme-success)' : status === 'error' ? 'var(--theme-error)' : undefined
    const base = status === 'error' ? 'var(--theme-error)' : undefined
    if (!base) return
    return `hsl(from ${base} h s ${isDarkTheme ? '15' : '85'}%)`
  }, [status, isDarkTheme])
  return (
    <Vertical
      alignItems='flex-start'
      verticalCenter
      style={{
        minHeight: '40px',
        flexGrow: 1,
        flexShrink: 0,
        padding: '0px 14px',
        backgroundColor,
      }}
    >
      {children}
    </Vertical>
  )
}
